import { Divider, GKTypography, Grid2 } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { moneyCommaSeparator } from "utils/MathFunction";
import { INDICES } from "utils/apiRoutes";
import { handleReturnPositiveNegative } from "utils/colorHelper";
import { QueryKeys } from "utils/queryKey";

// interface Props {
//   showDate?: boolean;
// }

const EquityCashSection = () => {
  // const { showDate } = props;

  const { data: niftyData, isFetching: niftyLoading } = useFetchQuery({
    key: [QueryKeys.NIFTY_SENSEX],
    retry: 0,
    route: INDICES,
  });
  return (
    <Grid2 container alignItems={"center"} justifyContent={"flex-end"}>
      <Grid2
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={2}
        px={2}
        py={1}
        sx={{
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
        }}
      >
        {/* <Show.When isTrue={showDate}>
          <Grid2
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
            px={2}
            py={1}
            color={"var(--neutral-500)"}
            sx={{
              borderTopRightRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            <GKTypography
              color={"var(--neutral-500)"}
              style={{
                display: "flex",
                alignItems: "center",
              }}
              fontSize={12}
              textAlign={"left"}
            >
              Last Summary Date
            </GKTypography>
            <GKTypography
              display="flex"
              alignItems="center"
              fontWeight={700}
              loading={niftyLoading}
              fontSize={16}
              color={theme.palette.dark.main}
            >
              {matchDate(niftyData?.data?.data?.lastCmpPrice)}
            </GKTypography>
          </Grid2>
          <Grid2>
            <Divider
              orientation="vertical"
              sx={{
                height: 16,
              }}
            />
          </Grid2>
        </Show.When> */}

        <Grid2
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={2}
          px={2}
          py={1}
          color={"var(--neutral-500)"}
          sx={{
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          <GKTypography
            color={"var(--neutral-500)"}
            style={{
              display: "flex",
              alignItems: "center",
            }}
            fontSize={12}
            textAlign={"left"}
          >
            NIFTY 50
          </GKTypography>
          <GKTypography
            display={"flex"}
            alignItems={"center"}
            fontWeight={700}
            loading={niftyLoading}
            fontSize={16}
          >
            {moneyCommaSeparator(niftyData?.data?.data?.nifty?.cmp)}{" "}
            <span
              style={{
                color: handleReturnPositiveNegative(
                  niftyData?.data?.data?.nifty?.ltp,
                ),
                fontWeight: 500,
                fontSize: 12,
                marginLeft: 4,
              }}
            >
              ({moneyCommaSeparator(niftyData?.data?.data?.nifty?.ltp)}%)
            </span>
          </GKTypography>
        </Grid2>
      </Grid2>
      <Grid2>
        <Divider
          orientation="vertical"
          sx={{
            height: 16,
          }}
        />
      </Grid2>
      <Grid2
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={2}
        px={2}
        py={1}
        color={"var(--neutral-500)"}
        sx={{
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
        }}
      >
        <GKTypography
          textAlign={"right"}
          fontSize={12}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          SENSEX
        </GKTypography>
        <GKTypography
          display={"flex"}
          alignItems={"center"}
          fontWeight={700}
          loading={niftyLoading}
          fontSize={16}
          color={"var(--black)"}
        >
          {moneyCommaSeparator(niftyData?.data?.data?.sensex?.cmp)}{" "}
          <span
            style={{
              color: handleReturnPositiveNegative(
                niftyData?.data?.data?.sensex?.ltp,
              ),
              fontWeight: 500,
              fontSize: 12,
              marginLeft: 4,
            }}
          >
            ({moneyCommaSeparator(niftyData?.data?.data?.sensex?.ltp)}%)
          </span>
        </GKTypography>
      </Grid2>
    </Grid2>
  );
};

export default EquityCashSection;
